import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toastify = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={true}
      pauseOnHover={true}
      theme="colored"
      toastStyle={{ zIndex: 10000 }} // Ensure Toasts are above everything
      style={{ zIndex: 10000 }} // Ensure container is above loader
    />
  );
};

export default Toastify;